import { Navigate } from 'react-router-dom'
import { logout } from '../Utils/Authentication'

export default function Logout() {
    logout();
    return <Navigate to="/login" />;
}
